<ng-container *transloco="let t">
    <div
        *ngIf="ngControl.control"
        [class]="'bazis-control bazis-range-control ' + cssClassSizeControl"
        [ngClass]="{
            'bazis-control--focused': isFocused,
            'bazis-control--dirty': ngControl.control.dirty,
            'bazis-control--empty':
                emptyValues.indexOf(ngControl.control.value?.from) > -1 &&
                emptyValues.indexOf(ngControl.control.value?.to) > -1,
            'bazis-control--invalid': ngControl.control.invalid,
            'bazis-control--disabled': disabled,
        }"
    >
        <ng-container
            *ngIf="{
                required: required$ | async,
                value: value.$ | async,
                values: values.$ | async,
            } as data"
        >
            <bazis-label
                [isMajor]="hasTitleMajor"
                [isEmptyLabel]="isEmptyLabel"
                [title]="title || t(titleKey, titleParams)"
                [required]="data.required"
            >
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </bazis-label>

            <div
                class="bazis-control__field-group"
                [class.bazis-control__field-group--disabled]="disabled"
                [class.bazis-control__field-group--focused]="isFocused"
            >
                <bazis-control-field-start
                    [isClickable]="isLeftIconClickable"
                    [icon]="leftIcon"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipSettings]="tooltipSettings"
                    (actionClick)="onLeftIconClick($event)"
                >
                </bazis-control-field-start>

                <div class="bazis-control__field">
                    <bazis-range
                        *ngIf="!dualThumbs"
                        [value]="data.value"
                        [min]="minNumber"
                        [max]="maxNumber"
                        [pin]="pin"
                        [step]="increment"
                        [disabled]="disabled"
                        [showScale]="showScale"
                        [customPinTemplate]="customPinTemplate"
                        [pinDimension]="unit || t(unitKey)"
                        (valueChanged)="updateValue($event)"
                    ></bazis-range>

                    <bazis-range
                        *ngIf="dualThumbs"
                        [values]="data.values"
                        [dualThumbs]="true"
                        [min]="minNumber"
                        [max]="maxNumber"
                        [pin]="pin"
                        [step]="increment"
                        [disabled]="disabled"
                        [showScale]="showScale"
                        [customPinTemplate]="customPinTemplate"
                        [pinDimension]="unit || t(unitKey)"
                        (valuesChanged)="updateValue($event)"
                    ></bazis-range>
                </div>

                <bazis-control-field-end
                    [isClickable]="isRightIconClickable"
                    [icon]="rightIcon"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipSettings]="tooltipSettings"
                    (actionClick)="onRightIconClick($event)"
                >
                </bazis-control-field-end>
            </div>

            <div class="bazis-control__error">
                <bazis-form-error
                    [formControl]="ngControl.control"
                    [validationErrorMessages]="validationErrorMessages"
                ></bazis-form-error>
                <ng-content></ng-content>
            </div>

            <div
                *ngIf="noteKey"
                class="bazis-control__note"
            >
                {{ t(noteKey, noteParams) }}
            </div>
        </ng-container>
    </div>
</ng-container>
